import { render, staticRenderFns } from "./ContactCustomize.vue?vue&type=template&id=82dcf9c8&"
import script from "./ContactCustomize.vue?vue&type=script&lang=js&"
export * from "./ContactCustomize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports